import { render, staticRenderFns } from "./BranchShow.vue?vue&type=template&id=ee0db522"
import script from "./BranchShow.vue?vue&type=script&lang=js"
export * from "./BranchShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports